import * as React from 'react';

import SvgIcon from '../../SvgIcon';

const SvgUpvoteFilled: React.FC<$TSFixMe> = (props) => (
  <SvgIcon {...props} viewBox="0 0 48 48" htmlAttributes={{ 'aria-hidden': true }}>
    <title>SvgUpvoteFilled</title>
    <polygon points="17.9726562 23.994873 6.85271794 23.994873 24.1144615 3.46445069 42.0405036 23.9357782 30.2181414 23.9357782 30.2181414 44.2382989 17.9726562 44.2382989" />
  </SvgIcon>
);

export default SvgUpvoteFilled;
